import { ThemeEvents } from "@theme/events";

const wideForCenteredThumbs = window.matchMedia("(min-width: 1201px)");

function applyThumbPagination(/** @type {HTMLElement} */ el) {
  if (wideForCenteredThumbs.matches) {
    el.setAttribute("pagination-position", "center");
    el.setAttribute("scroll-mode", "horizontal");
  } else {
    el.setAttribute("pagination-position", "right");
    el.setAttribute("scroll-mode", "vertical");
  }
}

/** Called after quick-add modal morph: `variant:update` from the card does not bubble to document. */
export function syncQuickAddModalGalleryControls() {
  document
    .querySelectorAll(
      '.quick-add-modal-media__gallery slideshow-controls[ref="slideshowControls"]',
    )
    .forEach((node) => {
      if (node instanceof HTMLElement) applyThumbPagination(node);
    });
}

syncQuickAddModalGalleryControls();
wideForCenteredThumbs.addEventListener("change", syncQuickAddModalGalleryControls);
document.addEventListener(ThemeEvents.variantUpdate, () => {
  queueMicrotask(syncQuickAddModalGalleryControls);
});
